import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Editor from "../../../../../../utils/common/Editor";

import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import SyncIcon from "@mui/icons-material/Sync";

const EmailGenerateItems = ({ content, handleInsertReply }: any) => {
  const handleOnChange = (value: any) => {};

  return (
    <Box
      sx={{
        border: "1px solid rgba(60, 64, 67, 0.2)",
        borderRadius: "8px",
        padding: "12px",
        marginBottom: "10px",
      }}
    >
      <Box mb="9px">
        <Editor
          readOnly
          editorData={content}
          updateData={handleOnChange}
          hideToolbar
        />
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Box>
          <Button
            variant="contained"
            sx={{
              borderRadius: "8px",
              boxShadow: "none",
            }}
            onClick={() => handleInsertReply(content)}
          >
            INSERT
          </Button>
        </Box>

        <Box display="flex" gap="4px">
          <IconButton
            sx={{
              background: "#ededee",
              borderRadius: "6px",
              padding: "0px 10px",
              color: "#646e82",
            }}
          >
            <ThumbUpOutlinedIcon />
          </IconButton>

          <IconButton
            sx={{
              background: "#ededee",
              borderRadius: "6px",
              padding: "0px 10px",
              color: "#646e82",
            }}
          >
            <ThumbDownOutlinedIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default EmailGenerateItems;
